<template>
  <div class="progress">
    <div
      :class="[{ complete: m.complete, active: m.number == step }, m.type]"
      v-for="m in moduleData.steps"
      :key="m.id"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Progress",
  computed: {
    step() {
      return parseInt(this.$route.params.step);
    },
    mod() {
      return parseInt(this.$route.params.module);
    },
    moduleData() {
      return this.$store.state.course.progress.progress.modules[this.mod - 1];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.progress {
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  display: flex;

  .step {
    width: 25px;
    height: 6px;
    border-radius: 4px;
    background: white;
    float: left;
    margin: 24px 8px;
    box-shadow: 1px 1px 4px #00000016;
  }

  .activity {
    width: 15px;
    height: 15px;
    border-radius: 4px;
    background: white;
    transform: rotate(45deg);
    margin: 20px 6px;
    float: left;
    box-shadow: 1px 1px 4px #00000016;
  }

  .complete {
    background: $secondary;
  }

  .active {
    background: $primary;
  }
}
</style>
